// ---------------------------------------------------------------------------
// Numeric-comparison grader-type descriptor. Authored in-page via the numeric
// flow; read-only after creation and has no Evaluate tab (it compares scores
// rather than running a model). Contributes the Scale + Comparison Overview
// cards. (Server→view spec mapping lives in the domain-layer mapper next to the
// Grader model, so this UI descriptor stays free of that concern.)
// ---------------------------------------------------------------------------

import { NumberSymbol20Regular } from '@fluentui/react-icons';
import { lazy } from 'react';

import type { GraderTypeDescriptor } from '../graderType.types.js';

import { NumericOverviewSections } from './NumericOverviewSections.js';

// Lazy so importing the registry (done by the lightweight create-method dialog,
// grader list, and Overview tab) does not eagerly pull the create flow's
// heavier module graph — the create layout loads only when actually rendered.
const NumericCreateLayout = lazy(() =>
  import('../../NumericCreateLayout/NumericCreateLayout.js').then((m) => ({
    default: m.NumericCreateLayout,
  })),
);

export const numericGraderDescriptor: GraderTypeDescriptor = {
  type: 'NumericComparisonGraderSpec',
  supportsEvaluate: false,
  OverviewSections: NumericOverviewSections,
  create: {
    method: 'numeric',
    menuTitle: 'Numeric comparison',
    menuDescription: 'Compare a predicted score to an expected one — no LLM.',
    menuIcon: <NumberSymbol20Regular />,
    renderLayout: () => <NumericCreateLayout />,
  },
};
